const getConsumerIdentification = _value => {
  let value = _value?.toString()?.replace(/\s\s+/g, ' ').trim()
  try {
    if (!value) return ''
    if (/[a-z.]/i.test(value)) return value
    value = value.replace(/\D/g, '')
    return parseInt(value).toLocaleString('es-AR') || value
  } catch { }

  return value
}

export const verifyFinancier = (financier) => {
  let errors = {};
  let financierIdentification = financier.identification?.replace(/\s+/g, '');

  let slug = financier.id?.replace("pms_financiers:", "").split("/").filter(Boolean)[0];
  if (!/wiri|private/i.test(slug) && !financierIdentification) {
    errors.identification = true
  }
  else if ((slug === "osde" || slug === "osde/")
    && !/^\d{11}$/.test(financierIdentification)) {
    errors.identification_format = true;
  }
  // Card 872 (corrección de QA, 2026-10-01): fila agregada con "+" sin una
  // cobertura elegida (`{ id: <uuid>, label: '' }`): el texto tipeado no llega al
  // form. Se marca la cobertura, no sólo el número de afiliado. Una cobertura
  // del catálogo tiene id `pms_financiers:…` aunque venga sin label.
  if (!financier.label && !/^pms_financiers:/.test(financier.id || "")) {
    errors.financier = true;
  }
  errors.flag =  errors.financier || errors.identification || errors.identification_format;

  return errors;
}

// Clave de la fila en `errors.financiers`. La 1ª fila del alta arranca como `{}`
// (sin id): sin este fallback por posición, una fila con sólo número de afiliado
// no tenía dónde guardar su warning.
export const financierKey = (financier, index) =>
  financier.id || financier.label || `index:${index}`;

const GENDER_VALID_VALUES = ["male", "female", "other"];

const verifyConsumer = (consumer) => {
  try {
    consumer ||= {};
    let errors = {}
    if (!consumer) return errors;

    let identification = getConsumerIdentification(consumer.identification);
    errors.identification = !identification || identification.length < 4;

    let firstName = consumer.firstName;
    let lastName = consumer.lastName;
    if (!firstName || !lastName) {
      // Bug real (auditoría 2026-08-14): consumer.label puede ser undefined
      // (un registro sin label seteado todavía) — sin el `|| ""`, el split
      // tiraba y quedaba atrapado por el catch de más afuera, haciendo que
      // TODA la validación devolviera undefined en silencio (sin ningún
      // error visible, como si el consumer fuera válido).
      [lastName, firstName] = (consumer.label || "").split(", ");
    }
    // Bug real (auditoría 2026-08-14): firstName/lastName de acá arriba
    // (con fallback al label cuando el campo directo falta) se calculaban
    // pero nunca se usaban — la validación seguía mirando
    // consumer.firstName/consumer.lastName directo, código muerto que
    // ignoraba por completo ese fallback.
    errors.firstName = !firstName;
    errors.lastName = !lastName;

    consumer.financiers ||= []
    // Card 872 (corrección de QA, 2026-10-01): se validaban sólo las filas con
    // id, y la 1ª fila del alta no tiene: con número de afiliado y sin cobertura
    // se guardaba igual. Se valida toda fila con cobertura o con número; la fila
    // vacía no (el paciente puede no tener cobertura).
    let financiers = consumer.financiers
      .map((financier, index) => ({ financier, index }))
      .filter(({ financier: f }) => (f.id || f.identification?.toString().trim()) && !f.deleted);

    errors.financiers = {};
    errors.financiers.validFinanciersCount = 0;

    for (let { financier, index } of financiers) {
      let key = financierKey(financier, index);
      errors.financiers[key] = verifyFinancier(financier);

      if (!errors.financiers[key].flag) errors.financiers.validFinanciersCount++;
      errors.financiers.flag ||= errors.financiers[key].flag;
    }

    if(!consumer.gender || !GENDER_VALID_VALUES.includes(consumer.gender)) {
      errors.gender = true
    }

    if(!consumer.dob) {
      errors.dob = true
    }

    errors.flag = errors.identification || errors.firstName || errors.lastName || errors.gender || errors.dob;
    return errors;
  } catch { }
};

export default verifyConsumer;
